export default __webpack_public_path__ + "static/media/play.6bbd09f3.svg";